export default "__VITE_ASSET__BREYfoP9__"